import React from 'react';

export default function CommonActionButton(props) {
  const { onClick, active, text, margin, padding } = props;

  return (
    <button
      className={`common-action-button ${active ? 'active' : ''}`}
      onClick={onClick}
      style={{ padding: padding ?? '0px 16px', margin: margin }}
    >
      <span>{text}</span>
    </button>
  );
}